import { CLIENTES } from "./types";

export const state: CLIENTES = {
  CODCLI: "",
  NOMCLI: "",
  AT_APP:  "" ,
  AT_PASSWORD:  "",
  CODREP:  "",
  E_MAIL:  "",
  NIFCLI:  "",
};
